<template>
  <div class="scoreboard-container"
    :style="{ backgroundImage: 'url(' + backgroundGif + ')' }">
    <!-- Back Button -->
    <a class="back-button" @click="goBack">⬅ {{ back_label[language] }}</a>

    <!-- User Scores Section -->
    <h2>{{ user_scores_title[language] }}</h2>

    <!-- Scrollable Table -->
    <div class="table-container">
      <table class="scores-table">
        <thead>
          <tr>
            <th>{{ game[language] }}</th>
            <th>{{ max_score[language] }}</th>
            <th>{{ times_played[language] }}</th>
            <th>{{ date_played[language] }}</th>
            <!-- <th>{{ time_played[language] }}</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(score, index) in scores" :key="index">
            <td>{{ score.gameName }}</td>
            <td>{{ score.score }}</td>
            <td>{{ score.timesPlayed }}</td>
            <td>{{ score.datePlayed }}</td>
            <!-- <td>{{ score.timePlayed }}</td> -->
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Message for no scores -->
    <p v-if="scores.length === 0">{{ no_scores[language] }}</p>

    <!-- Seed Points Section -->
    <h2>{{ seed_points_title[language] }}</h2>
    <div class="seeds-container">
      <div class="seed-box blue">{{ blue_seeds[language] }}: {{ seeds.blue }}</div>
      <div class="seed-box red">{{ red_seeds[language] }}: {{ seeds.red }}</div>
      <div class="seed-box green">{{ green_seeds[language] }}: {{ seeds.green }}</div>
      <div class="seed-box yellow">{{ yellow_seeds[language] }}: {{ seeds.yellow }}</div>
    </div>
  </div>
</template>

<script>
import { sounds } from '@/utils/sounds.js';

export default {
  data() {
    return {
isShuttingDown: false,
      backgroundGif: require('@/assets/world/maximum.gif'),

      language: localStorage.getItem("language") || "en", // Default to English if no language is set
      back_label: { en: "Back", el: "Πίσω", it: "Indietro", ro: "Înapoi", uk: "Назад" },
      user_scores_title: { en: "User Scores", el: "Βαθμολογία Χρήστη", it: "Punteggi Utente", ro: "Scoruri Utilizator", uk: "Бали користувача" },
      game: { en: "Game", el: "Παιχνίδι", it: "Gioco", ro: "Joc", uk: "Гра" },
      max_score: { en: "Max Score", el: "Μέγιστο σκορ", it: "Punteggio Massimo", ro: "Scor Maxim", uk: "Макс. бал" },
      times_played: { en: "Times Played", el: "Πλήθος επαναλήψεων", it: "Volte Giocato", ro: "Ori Jucat", uk: "Кількість Ігор" },
      date_played: { en: "Date Played", el: "Ημερομηνία", it: "Data Giocato", ro: "Data Jucat", uk: "Дата Ігри" },
      time_played: { en: "Time Played", el: "Διάρκεια", it: "Tempo Giocato", ro: "Timp Jucat", uk: "Час Ігри" },
      no_scores: { en: "No scores available.", el: "Δεν υπάρχουν διαθέσιμοι βαθμοί.", it: "Nessun punteggio disponibile.", ro: "Nu sunt scoruri disponibile.", uk: "Немає доступних балів." },
      seed_points_title: { en: "Total Seed Points", el: "Συνολικοί Σπόροι", it: "Punti di Semina Totali", ro: "Total Puncte Semințe", uk: "Загальні Очки Насіння" },
      blue_seeds: { en: "Blue Seeds", el: "Μπλε σπόροι", it: "Semi Blu", ro: "Semințe Albastre", uk: "Сині Насіння" },
      red_seeds: { en: "Red Seeds", el: "Κόκκινοι σπόροι", it: "Semi Rossi", ro: "Semințe Roșii", uk: "Червоні Насіння" },
      green_seeds: { en: "Green Seeds", el: "Πράσινοι σπόροι", it: "Semi Verdi", ro: "Semințe Verzi", uk: "Зелені Насіння" },
      yellow_seeds: { en: "Yellow Seeds", el: "Κίτρινοι σπόροι", it: "Semi Gialli", ro: "Semințe Galbene", uk: "Жовті Насіння" },
      scores: [], // Array to store processed scores
      seeds: { blue: 0, red: 0, green: 0, yellow: 0 }, // Seed counts

      // gameNames[score.gameName][language];


      gameNames : {
        
        StretchingGame: { en: 'Stretching', el: 'Διατάσεις', it: 'Stretching', ro: 'Întindere', uk: 'Розтяжка' },
      
      PickTheOddGame: { en: 'Find the Odd', el: 'Βρες το λάθος', it: 'Scegli il diverso', ro: 'Alege diferitul', uk: 'Вибери зайве' },
      SelectMealGame: { en: 'Select Meal', el: 'Αντιστοίχιση στο γεύμα', it: 'Seleziona pasto', ro: 'Selectează masa', uk: 'Вибери страву' },
      FoodMatchingGame: { en: 'Food Matching', el: 'Ταξινόμηση τροφίμων', it: 'Abbinamento cibi', ro: 'Potrivire alimente', uk: 'Співставлення їжі' },
      FoodPyramidGame: { en: 'Food Pyramid', el: 'Διατροφική πυραμίδα', it: 'Piramide alimentare', ro: 'Piramida alimentară', uk: 'Харчова піраміда' },

      HandsGame: { en: 'Hands Game', el: 'Πιάσε τα αστέρια', it: 'Gioco delle mani', ro: 'Joc de mâini', uk: 'Гра з руками' },
      FramesGame: { en: 'Frames', el: 'Μπες στο καρέ', it: 'Cornici', ro: 'Cadre', uk: 'Кадри' },
      JumpsPrecisionGame: { en: 'Jumps Precision', el: 'Άλματα με ακρίβεια', it: 'Precisione nei salti', ro: 'Precizie în sărituri', uk: 'Точність стрибків' },
      RunningGame: { en: 'Running', el: 'Τρέξιμο', it: 'Corsa', ro: 'Alergare', uk: 'Біг' },
      BodyMoveGame: { en: 'Body Move', el: 'Κίνηση σώματος', it: 'Movimento del corpo', ro: 'Mișcare corp', uk: 'Рух тіла' },
      JumpRopeGame: { en: 'Jump Rope', el: 'Σχοινάκι', it: 'Corda per saltare', ro: 'Coardă', uk: 'Скакалка' },
      JumpsGame: { en: 'Jumps', el: 'Άλματα', it: 'Salti', ro: 'Sărituri', uk: 'Стрибки' },

      HighKneesGame: { en: 'High Knees', el: 'Γόνατα ψηλά', it: 'Ginocchia alte', ro: 'Genunchi sus', uk: 'Високі коліна' },
      SitupsGame: { en: 'Situps', el: 'Κοιλιακοί', it: 'Addominali', ro: 'Abdomene', uk: 'Прес' },
      PushupsGame: { en: 'Pushups', el: 'Κάμψεις', it: 'Flessioni', ro: 'Flotări', uk: 'Віджимання' },
      JumpingJacksGame: { en: 'Jumping Jacks', el: 'Άλματα Jumping Jacks', it: 'Saltelli Jumping Jacks', ro: 'Sărituri Jumping Jacks', uk: 'Стрибки Jumping Jacks' },
      PlankGame: { en: 'Plank', el: 'Σανίδα', it: 'Plank', ro: 'Plank', uk: 'Планка' },
      },
    };
  },
  methods: {
    async loadScores() {
      this.scores = [];
      const allScores = [];
      const username = localStorage.getItem("username"); // Get logged-in username
      // const language = localStorage.getItem("language"); // Get logged-in username


      if (!username) {
        console.error("User not logged in.");
        return;
      }

      // Load scores from IndexedDB (Offline)
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        try {
          const gameScores = JSON.parse(localStorage.getItem(key));
          if (Array.isArray(gameScores)) {
            const userScores = gameScores.filter(score => score.username === username);
            allScores.push(...userScores);
          }
        } catch (error) {
          console.warn(`Skipping non-JSON value in localStorage: ${key}`);
        }
      }

      // Fetch scores from MongoDB when online
      if (navigator.onLine) {
        try {
          const token = localStorage.getItem("token");

          const response = await fetch("https://erebus2.athenarc.gr/duse/get-user-scores", {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
          });

          if (response.ok) {
            const mongoScores = await response.json();
            allScores.push(...mongoScores);
          } else {
            console.error("Failed to fetch scores from MongoDB.");
          }
        } catch (error) {
          console.error("Error fetching MongoDB scores:", error);
        }
      }

      // Process scores: find max score and times played per game
      const uniqueScores = {};

      // console.log(allScores);
      // console.log(this.gameNames);
      console.log(this.gameNames[allScores[0].gameName][this.language])
      allScores.forEach((score) => {
        console.log(score);
        
        if (!uniqueScores[score.gameName]) {
          uniqueScores[score.gameName] = { ...score, timesPlayed: 1 };
        } else {
          uniqueScores[score.gameName].timesPlayed++;
          if (uniqueScores[score.gameName].score < score.score) {
            uniqueScores[score.gameName].score = score.score;
          }
        }
        uniqueScores[score.gameName].gameName = this.gameNames[score.gameName][this.language];
      });

      this.scores = Object.values(uniqueScores);

      // Load seed points after scores are loaded
      await this.loadSeedPoints();
    },

    async loadSeedPoints() {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const response = await fetch("https://erebus2.athenarc.gr/duse/get-seed-points", {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.ok) {
          const data = await response.json();
          this.seeds = data.seeds || { blue: 0, red: 0, green: 0, yellow: 0 };
        } else {
          console.error("Failed to fetch seed points.");
        }
      } catch (error) {
        console.error("Error fetching seed points:", error);
      }
    },

    async goBack() {
      sounds.whoosh.play();
      this.isShuttingDown = true;
      this.$router.push({ name: "MainScene" }); // Navigate to the Main Scene
    },
  },
  created() {
    this.language = localStorage.getItem("language") || "en";
    console.log("LANGUAGE " + this.language);
  },
  mounted() {
    sounds.settings_menu.play();
    this.loadScores();

    window.addEventListener("online", async () => {
      console.log("Back online! Fetching latest scores and seed points...");
      await this.loadScores();
    });
  },
  beforeUnmount() {
    sounds.settings_menu.stop();
  },
};
</script>

<style scoped>
.scoreboard-container {
  display: flex;
  flex-direction: column; /* Stack elements vertically for mobile */
  align-items: center;
  justify-content: flex-start;
  height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #2c3e50;
  color: white;
  overflow-y: auto; /* Make the entire container scrollable */
  padding: 20px; /* Add some padding for better layout */
}

.content-container {
  background-color: white;
  border-radius: 12px; /* Rounded corners */
  padding: 20px;
  width: 100%;
  max-width: 500px; /* Limit width to prevent too large on bigger screens */
  margin-top: 60px; /* Space between the back button and the white box */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Light shadow for better contrast */
}

h2 {
  text-align: center;
  margin-bottom: 2px;
  font-size: 1.5rem; /* Smaller font for mobile */
  background-color: rgba(255, 255, 255, 0.9);
  color: black;
  border-radius: 8px;
  padding: 8px;
}

.table-container {
  max-height: 300px; /* Reduced height for mobile */
  overflow-y: auto;
  width: 100%;
  margin-top: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.9);
}

.scores-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem; /* Smaller font size for table cells */
}

.scores-table th,
.scores-table td {
  border: 1px solid #ddd;
  padding: 6px;
  text-align: center;
  color: black;
}

.scores-table th {
  background-color: #0077cc;
  color: white;
  position: sticky; /* Make the header sticky */
  top: 0; /* Stick to the top */
  z-index: 1; /* Ensure it stays on top of the scrolling content */
}

.scores-table td {
  background-color: rgba(255, 255, 255, 0.9);
}

p {
  text-align: center;
  font-style: italic;
  font-size: 1rem; /* Adjust font size for better readability */
}

.seeds-container {
  display: flex;
  flex-wrap: wrap; /* Allow items to wrap on smaller screens */
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
  width: 100%;
}

.seed-box {
  padding: 10px 15px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  width: 45%; /* Make seed boxes responsive */
  min-width: 100px; /* Set a minimum width for small screens */
}

.blue {
  background-color: #3498db;
  color: white;
}

.red {
  background-color: #e74c3c;
  color: white;
}

.green {
  background-color: #2ecc71;
  color: white;
}

.yellow {
  background-color: #f1c40f;
  color: black;
}

.back-button {
  position: absolute;
  top: 20px;
  left: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  z-index: 1001;
}

@media (max-width: 600px) {
  .scoreboard-container {
    padding: 10px; /* Less padding on smaller screens */
  }

  .seed-box {
    font-size: 14px; /* Adjust font size on small screens */
    width: 100%; /* Make seed boxes take full width */
    min-width: 0; /* Remove minimum width on mobile */
  }

  h2 {
    font-size: 1.2rem; /* Adjust heading size */
  }

  .content-container {
    padding: 15px; /* Less padding for mobile */
  }
}

</style>
